import { render, staticRenderFns } from "./SuspendEmployeeAccess.vue?vue&type=template&id=d4ab18d6&scoped=true"
import script from "./SuspendEmployeeAccess.vue?vue&type=script&lang=js"
export * from "./SuspendEmployeeAccess.vue?vue&type=script&lang=js"
import style0 from "./SuspendEmployeeAccess.vue?vue&type=style&index=0&id=d4ab18d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ab18d6",
  null
  
)

export default component.exports